import Footer from "../components/footer";
import { icons } from "../assets/icons";
import { certifications } from "../data/data";

const Certifications = () => {
  return (
    <div className="App flex flex-col justify-center font-geist">
      <div className="flex flex-col py-8 px-4 w-full max-w-[900px] mx-auto">
        <div>
          <span className="flex items-center gap-2">
            <a
              href="/"
              className="transform transition-transform duration-500 ease-in-out hover:-translate-x-1"
            >
              {icons.arrowLeft}
            </a>
            <span className="font-semibold text-xl">All Certifications</span>
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-7">
          {certifications.map((certification) => (
            <a
              key={certification.name}
              className="bg-[#111111] border border-gray-600 py-3 px-4 rounded-lg transform transition-transform hover:-translate-y-0.5 duration-300 flex flex-col"
              href={certification.url}
              target="_blank"
              rel="noreferrer"
            >
              <h1 className="font-bold text-lg tracking-tight">
                {certification.name}
              </h1>
              <p className="my-1">{certification.provider}</p>
            </a>
          ))}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default Certifications;
